import AuthorTile from "@/components/AuthorTile";
import Container from "@/components/Container";
import RecommendedWrapper from "@/components/Recommended/RecommendedWrapper";
import { apiPath } from "@/helpers/apiPath";
import useRequest from "@/helpers/useRequest";

import styles from "../EmptyState.module.scss";

const SuggestedAuthors = () => {
  const { data: authors } = useRequest(
    apiPath.REDACTORS,
    {},
    { field: "popularity", direction: "desc" }
  );

  return (
    <RecommendedWrapper title="Popularni redaktorzy" className={styles.heading}>
      <Container className={styles.authorsContainer}>
        {authors?.slice(0, 6).map((author) => {
          return <AuthorTile key={author.slug} {...author} />;
        })}
      </Container>
    </RecommendedWrapper>
  );
};

export default SuggestedAuthors;
